import { render, staticRenderFns } from "./guessLikeDetail.vue?vue&type=template&id=0c2803b6&scoped=true&"
import script from "./guessLikeDetail.vue?vue&type=script&lang=js&"
export * from "./guessLikeDetail.vue?vue&type=script&lang=js&"
import style0 from "./guessLikeDetail.vue?vue&type=style&index=0&id=0c2803b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2803b6",
  null
  
)

component.options.__file = "guessLikeDetail.vue"
export default component.exports